<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="(data.team.id ? 'Edit' : 'Add') + ' Team'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.team !== undefined && data.team !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="teamNameFormControl" placeholder="Name (required)" (blur)="saveTeam('name')"
              >
            @if (teamNameFormControl.hasError('minlength') && !teamNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (teamNameFormControl.hasError('required')) {
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Short Name</mat-label>
            <input type="text" matInput [formControl]="teamShortNameFormControl" placeholder="Short Name (required)" (blur)="saveTeam('shortName')"
              value="{{ data.team.shortName }}">
            @if (teamShortNameFormControl.hasError('minlength') && !teamShortNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (teamShortNameFormControl.hasError('required')) {
              <mat-error>
                Short Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input
              type="text"
              matInput
              placeholder="Header Row Metadata (Height)"
              [value]="data.team.email"
              [formControl]="emailFormControl"
              placeholder="Email"
              (blur)="saveTeam('email')"
              title="Team Email"
              />
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin left">
        <div>
          <p style="font-size: 13px; font-weight: 400; line-height: 1.125; letter-spacing: normal;">
            Description
          </p>
          <div>
            <angular-editor [placeholder]="'Description'" [formControl]="descriptionFormControl" [config]="editorConfig"
              (blur)="saveTeam('description')"></angular-editor>
          </div>
        </div>
      </div>
      @if (data.useCite) {
        <div class="add-margin">
          <div>
            <mat-form-field class="full-width">
              <mat-label>CITE Team Type (required)</mat-label>
              <mat-select
                [value]="data.team.citeTeamTypeId"
                [formControl]="citeTeamTypeIdFormControl"
                (selectionChange)="saveTeam('citeTeamTypeId')"
                >
                <mat-option [value]="''"></mat-option>
                @for (teamType of data.teamTypeList; track teamType) {
                  <mat-option [value]="teamType.id">
                    {{ teamType.name }}
                  </mat-option>
                }
              </mat-select>
              @if (citeTeamTypeIdFormControl.hasError('required')) {
                <mat-error>
                  CITE Team Type is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
      @if (data.casterTeamVariables || data.team.casterTeamVariable) {
        <div class="add-margin">
          <div>
            <mat-form-field class="full-width">
              <mat-label>Topology Team</mat-label>
              <mat-select
                [formControl]="casterTeamVariableFormControl"
                (selectionChange)="saveTeam('casterTeamVariable')"
                >
                <mat-option [value]="''">By team name</mat-option>
                @for (variable of topologyTeamOptions(); track variable) {
                  <mat-option [value]="variable">
                    {{ topologyTeamLabel(variable) }}
                  </mat-option>
                }
              </mat-select>
              <mat-hint>The Caster template variable this team's Player team ID is written to</mat-hint>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="add-margin">
        <div>
          <mat-checkbox
            [(ngModel)]="data.team.canTeamMemberInvite"
            class="bottom-margin"
            >
            ALL users can invite others to this team
          </mat-checkbox><br />
        </div>
      </div>
    </div>
  }
</crucible-dialog>
